import { useTranslate } from '@tolgee/react';
import { DetailCard } from 'components/LightConversation/components/DetailCard';
import { Divider } from 'antd';
import { Total } from './Total';
import { PaymentSection } from './PaymentSection';

interface PayCardProps {
  order: Conversation.Trade.Vo;
}

export const PayCard = (props: PayCardProps) => {
  const { order } = props;
  const { t } = useTranslate();
  const { paymentMethod } = order;

  return (
    <DetailCard
      title={t('付款')}
      titleDescription={
        paymentMethod ? (
          <span className="text-[#84868C]" title={paymentMethod}>
            [{paymentMethod}]
          </span>
        ) : null
      }
    >
      <PaymentSection order={order} />
      <Divider className="!my-1 !border-[#EDEDED]" dashed />
      <Total order={order} />
    </DetailCard>
  );
};
